import { createContext, useContext } from "react";

const UserMenuContext = createContext(undefined);

export const UserMenuProvider = (props) => (
  <UserMenuContext.Provider {...props} />
);
export const useUserMenuContext = () => useContext(UserMenuContext);
